import { cn } from "../lib/utils";

export function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between animate-fade-up">
      <div>
        {eyebrow && (
          <p className="mb-1.5 text-[11px] font-bold uppercase tracking-[0.22em] text-brand">{eyebrow}</p>
        )}
        <h1 className="font-heading text-3xl font-extrabold tracking-tight sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-2 max-w-2xl text-muted-foreground">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, hint, accent }) {
  return (
    <div className="rounded-xl border border-border bg-card p-5 transition-shadow hover:shadow-sm" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-muted-foreground">{label}</p>
        {Icon && (
          <span className={cn("grid h-8 w-8 place-items-center rounded-lg", accent || "bg-brand-muted text-brand")}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <p className="mt-3 font-heading text-3xl font-extrabold tracking-tight">{value}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-card/50 px-6 py-16 text-center" data-testid="empty-state">
      {Icon && (
        <div className="mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-brand-muted text-brand">
          <Icon className="h-7 w-7" />
        </div>
      )}
      <h3 className="font-heading text-lg font-bold">{title}</h3>
      {subtitle && <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

const STATUS_MAP = {
  active: { label: "Active", cls: "bg-success/12 text-success border-success/30" },
  expiring: { label: "Expiring soon", cls: "bg-warning/12 text-warning border-warning/30" },
  expired: { label: "Expired", cls: "bg-destructive/12 text-destructive border-destructive/30" },
  issued: { label: "Unclaimed", cls: "bg-muted text-muted-foreground border-border" },
  claimed: { label: "Claimed", cls: "bg-brand-muted text-brand border-brand/30" },
  transferred: { label: "Transferred", cls: "bg-brand-muted text-brand border-brand/30" },
  self_added: { label: "Self-added", cls: "bg-accent text-accent-foreground border-border" },
};

export function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || { label: status, cls: "bg-muted text-muted-foreground border-border" };
  return (
    <span className={cn("inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-bold", s.cls)}>
      {s.label}
    </span>
  );
}

export function money(n, currency = "AUD") {
  const val = typeof n === "number" ? n : 0;
  return new Intl.NumberFormat("en-AU", { style: "currency", currency }).format(val);
}

export function shortDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
}
